import sseclient from "../utils/sseclient";

class atlasApi  {
	

	apiUrl				= process.env.REACT_APP_API_URL;
	authToken			= '';
	apiVersion			= '/v3';
	// Async function provided by AuthGate that returns a fresh WorkOS access
	// token (the SDK refreshes it automatically when near expiry).
	tokenProvider		= null;

	requestSignals		= {};
	_pending			= {};

	headers = ()=> {
		return {
			'Authorization': `Bearer ${this.authToken}`,
			'Content-Type': 'application/json'
		}
	};
	uploadHeaders = ()=> {
		return {
			'Authorization': `Bearer ${this.authToken}`
		}
	}

	ownerEndpoint				= (oId)				=> `${this.apiUrl}${this.apiVersion}/landowners/${oId ? oId+'/':''}`;
	propertyEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/property/`;
	projectsEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/projects/`;
	projectsMiniEndpoint		= ()				=> `${this.apiUrl}${this.apiVersion}/projects/mini/`;
	projectEndpoint				= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/`;
	scenariosEndpoint			= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/`;
	scenarioEndpoint			= (pId, sId, vId, wm, kwh_price, aep)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/?${wm ? 'workMode='+wm : 'workMode=default'}${vId ? '&versionid='+vId : ''}${kwh_price ? '&kwh_price='+kwh_price : ''}${aep ? '&aep='+aep : ''}`;
	//scenariov1Endpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/`;
	scenarioOwnersEndpoint	= (pId, sId, vId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/landowners/scenarios/${sId}/`+(vId ? '?versionid='+vId : '');
	//scenarioPropertiesEndpoint= (pId, sId, vId)	=> `${this.apiUrl}${apiVersion}/projects/${pId}/properties/scenarios/${sId}/`+(vId ? '?versionid='+vId : '');
	//turbinesEndpoint			= (pId, sId)		=> `${this.apiUrl}${apiVersion}/projects/${pId}/scenarios/${sId}/wtgs`;
	//turbineEndpoint			= (pId, sId, tId)	=> `${this.apiUrl}${apiVersion}/projects/${pId}/scenarios/${sId}/wtgs/${tId}/`;
	//turbineLocationsEndpoint	= (pId)				=> `${this.apiUrl}${apiVersion}/projects/${pId}/wtgs`;
	projectsBoundariesEndpoint= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/map/`;
	requestOwnersEndpoint		= (pId, sId, wm)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/getLandowners/?${wm ? 'workMode='+wm : 'workMode=default'}`;
	setMainScenarioEndpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/setToMain/`;
	getScenarioHistEndpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/versions/`;
	updatePropertyOwnEndpoint	= (oId)				=> `${this.apiUrl}${this.apiVersion}/landowners/${oId}/associateProperty/`;
	requestPlotInfoEndpoint		= ()				=> `${this.apiUrl}${this.apiVersion}/properties/getLandowners/`;
	addDialogEndpoint			= (oId)				=> `${this.apiUrl}${this.apiVersion}/landowners/${oId}/addDialog/`;
	deleteDialogEndpoint		= (dId)				=> `${this.apiUrl}${this.apiVersion}/landowners/dialogs/${dId}/`;
	projectStateEndpoint		= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/updateState/`;
	settingsEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/settings/`;
	notesEndpoint				= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/notes/`;
	searchLandOwners			= (params)			=> {
		const q = new URLSearchParams();
		if(params && typeof params === 'object'){
			Object.entries(params).forEach(([key, val]) => { if(val !== undefined && val !== null && val !== '') q.append(key, val); });
		} else if(params) {
			q.append('query', params);
		}
		return `${this.apiUrl}${this.apiVersion}/landowners/search/?${q.toString()}`;
	};
	searchPropertiesEndpoint	= (q)				=> `${this.apiUrl}${this.apiVersion}/properties/search/?query=${q}`;
	disassociatePropEndpoint	= (oId)				=> `${this.apiUrl}${this.apiVersion}/landowners/${oId}/disassociateProperty/`;
	getLayerLibrary				= (pId)				=> `${this.apiUrl}${this.apiVersion}/uploads/geo/?project_id=${pId}`;
	downloadLibLayerEndpoint	= (layer)			=> `${this.apiUrl}${this.apiVersion}/uploads/${layer}/download/`;
	deleteLayerEndpoint			= (layer)			=> `${this.apiUrl}${this.apiVersion}/uploads/${layer}/`;
	uploadLayerLibrary			= (q)				=> `${this.apiUrl}${this.apiVersion}/uploads/geo/`;
	uploadedLayerEndpoint		= (lId)				=> `${this.apiUrl}${this.apiVersion}/uploads/${lId}/`;
	uploadedLayerBBEndpoint		= (uId)				=> `${this.apiUrl}${this.apiVersion}/uploads/${uId}/bbox/`;
	layerConfigEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/layers/`;
	layerPropertiesEndpoint		= (lId)				=> `${this.apiUrl}${this.apiVersion}/uploads/${lId}/`;
	layerFeaturesEndpoint		= (table, q)		=> `${this.apiUrl}${this.apiVersion}/uploads/${table}/features/?${q}`;
	convertLayerEndpoint		= ()				=> `${this.apiUrl}${this.apiVersion}/projects/convert/`;
	cadastralSearchBGEndpoint	= (q)				=> `${this.apiUrl}${this.apiVersion}/cadastral/bg/search/?q=${encodeURIComponent(q)}`;
	cadastralFeaturesBGEndpoint	= ()				=> `${this.apiUrl}${this.apiVersion}/cadastral/bg/features/`;
	downloadProjectFileEndpoint	= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/download/`;
	getPreviousOwnersEndpoint	= (pId)				=> `${this.apiUrl}${this.apiVersion}/property/${pId}/previousOwners/`;
	setRoadWidthEndpoint		= (pId, sId, rId, width) => `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/roads/${rId}/width/${width}/`;
	setPowerlineWidthEndpoint	= (pId, sId, plId, width) => `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/powerlines/${plId}/width/${width}/`;
	powerlinesEndpoint			= (pId, sId)			=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/powerlines/`;
	powerlineEndpoint			= (pId, sId, plId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/powerlines/${plId}/`;
	roadsEndpoint				= (pId, sId)			=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/roads/`;
	roadEndpoint				= (pId, sId, rId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/roads/${rId}/`;
	autoroadsMappingEndpoint		= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/autoroads/mapping/`;
	autoroadsCalculationEndpoint	= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/autoroads/calculation/`;
	autoroadsCalculateEndpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/autoroads/calculate/`;
	autoroadsRoutesEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/autoroads/routes/`;
	autoroadsRoutesSyncEndpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/autoroads/routes/sync/`;
	scenarioChangesEndpoint		= (pId, sId, limit)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/changes/?limit=${limit}`;
	getPropAttributesEndpoint	= (pId)				=> `${this.apiUrl}${this.apiVersion}/property/${pId}/attributes/`;
	propAttributeEndpoint		= (pId, aId)		=> `${this.apiUrl}${this.apiVersion}/property/${pId}/attributes/${aId}/`;
	getUserMapsEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/sandbox/maps/`;
	getUserMapEndpoint			= (mId)				=> `${this.apiUrl}${this.apiVersion}/sandbox/maps/${mId}`;
	userMapsEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/sandbox/maps/`;
	copyUserMapEndpoint			= (mId)				=> `${this.apiUrl}${this.apiVersion}/sandbox/maps/${mId}/duplicate`;
	propertyBBEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/property/geojson/`;
	windRoseEndpoint			= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/windrose/energy/`;
	windSpeedEndpoint			= (height,lat,lng)	=> `${this.apiUrl}${this.apiVersion}/windspeed/height/${height}/coordinates/${lat}/${lng}`;
	createBufferEndpoint		= (uId, m)			=> `${this.apiUrl}${this.apiVersion}/uploads/${uId}/buffer/${m}/`;
	scenarioAEPEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarioes/${sId}/iaep/`;
	turbineTypesEndpoint		= ()				=> `${this.apiUrl}${this.apiVersion}/turbine_types`;
	turbineHeightsEndpoint		= (h)				=> `${this.apiUrl}${this.apiVersion}/hub_heights${h ? '?turbine_type='+h:''}`;
	turbinesEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/turbines/`;
	turbineEndpoint				= (pId, sId, tId)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/turbines/${tId}/`;
	turbineNameEndpoint			= (pId, sId, tId)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/turbines/${tId}/`;
	setColorEndpoint			= (oId)				=> `${this.apiUrl}${this.apiVersion}/landowners/${oId}/set/color/`;
	getRequestProgress			= (wm, pId)			=> `${this.apiUrl}/stream?channel=get-landowners-${wm}-${pId}`;
	requestPlotInfoEndpointP	= ()				=> `${this.apiUrl}${this.apiVersion}/properties/getLandownersProgressive/`;
	noiseLayerEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/noise/`;
	shadowLayerEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/shadow/`;
	annotationsEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/annotations/`;
	annotationEndpoint			= (pId, sId, aId)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/annotations/${aId}/`;
	addLayerProjectEndpoint		= (lId)				=> `${this.apiUrl}${this.apiVersion}/uploads/${lId}/project/`;
	favoritesEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/favorites/`;
	usersEndpoint				= ()				=> `${this.apiUrl}${this.apiVersion}/users/`;
	docsEndpoint				= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/sharepoint/`;
	tagsEndpoint				= (pId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/tags/`;
	tagColorsEndpoint			= ()				=> `${this.apiUrl}${this.apiVersion}/tag/colors/`;
	calcProgressEndpoint		= (type, pId, sId)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/${type}/status/`;
	circlesEndpoint				= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/turbines/circles/`;
	circleEndpoint				= (pId, sId, cId)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/turbines/circles/${cId}/`;
	ellipseEndpoint				= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/turbines/ellipse/`;
	downloadProjsEndpoint		= (format)			=> `${this.apiUrl}${this.apiVersion}/projects/export/?fileType=${format}`;
	metricsPipelineEndpoint		= (energyType, dates)=> `${this.apiUrl}${this.apiVersion}/metrics/pipeline/?energy_type=${energyType}${dates ? '&dates='+dates : ''}`;
	metricsProjectsEndpoint		= (country, energyType, compareDate)=> `${this.apiUrl}${this.apiVersion}/metrics/projects/?${country ? 'country='+country+'&' : ''}${energyType ? 'energy_type='+energyType+'&' : ''}${compareDate ? 'compare_date='+compareDate : ''}`;
	exclusionsEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/exclusions/`;
	exclusionPolyEndpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/exclusions/polygon/`;
	exclusionPointEndpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/exclusions/point/`;
	exclusionEndpoint			= (pId, sId, eId)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/exclusions/${eId}`;
	exclusionExtractEndpoint	= (pId, sId, tId, slope, buffer)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/exclusions/type/${tId}?slope_threshold=${slope}&buffer_km=${buffer}`;
	drawingsEndpoint			= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/drawings/`;
	drawingEndpoint				= (pId, sId, dId)	=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/drawings/${dId}/`;
	exclusionUploadEndpoint		= (pId, sId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/exclusions/upload/`;
	favoritesEndpointv2			= (type)			=> `${this.apiUrl}${this.apiVersion}/${type}/favorites/`;
	compensationEndpoint		= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/compensation/`;
	boundaryEndpoint			= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/boundary/`;
	sensorsEndpoint				= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/sensors/`;
	sensorEndpoint				= (pId, sId, nsaId)			=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/sensors/${nsaId}/`;
	wtgSettingsEndpoint			= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/wtg/settings/`;
	undoEndpoint				= (pId, sId, changeId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/undo/?change_id=${changeId}`;
	redoEndpoint				= (pId, sId, changeId)		=> changeId ? `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/redo/?change_id=${changeId}` : `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/redo/?all=true`;
	changePreviewEndpoint		= (pId, sId, changeId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/changes/${changeId}/preview/`;
	changeCopyEndpoint			= (pId, sId, changeId)		=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/changes/${changeId}/copy/`;
	scenarioEditEndpoint		= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/edit/`;
	gatesEndpoint				= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/entrygates/`;
	gateEndpoint				= (pId, sId, gId)			=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/entrygates/${gId}/`;
	substationsEndpoint			= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/substations/`;
	substationEndpoint			= (pId, sId, ssId)			=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/substations/${ssId}/`;
	reportsEndpoint				= (pId, sId)				=> `${this.apiUrl}${this.apiVersion}/projects/${pId}/scenarios/${sId}/reports/`;
	tileserverConfigEndpoint	= ()						=> `${this.apiUrl}${this.apiVersion}/config/tileserver/`;
	// COG-flisserveren i API-et. {z}/{x}/{y} står med vilje igjen som
	// plassholdere — det er Mapbox som fyller dem inn.
	cogTilesEndpoint			= (layer)					=> `${this.apiUrl}${this.apiVersion}/tiles/${layer}/{z}/{x}/{y}.png`;
		
		

	emptySet ={
		type: 'FeatureCollection',
		features: []  // <--- no features
	};

	async saveBoundary(pId, sId, coordinates){
		try {
			const geometry = coordinates.length === 1
				? { type: 'Polygon', coordinates: coordinates[0] }
				: { type: 'MultiPolygon', coordinates: coordinates };

			const response = await fetch(this.boundaryEndpoint(pId, sId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({ geometry }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error saving boundary:', error);
			throw error;
		}
	}

	setTokenProvider(fn){
		this.tokenProvider = fn;
	}

	// Tileserver address and API key for the map. Served only to logged-in
	// users so the key stays out of the build. Cached — the values don't
	// change within a session.
	async getTileserverConfig(){
		if(this._tilesConfig) return this._tilesConfig;
		if(this._pending.getTileserverConfig) return this._pending.getTileserverConfig;
		this._pending.getTileserverConfig = fetch(this.tileserverConfigEndpoint(), {
			method: 'GET',
			headers: this.headers(),
		}).then(async (response) => {
			if(!response.ok)
				throw new Error(`Tileserver config request failed: ${response.status}`);
			this._tilesConfig = await response.json();
			return this._tilesConfig;
		}).finally(() => {
			delete this._pending.getTileserverConfig;
		});
		return this._pending.getTileserverConfig;
	}

	async getToken(){
		try {
			if(!this.tokenProvider)
				throw new Error('No token provider set — AuthGate has not initialized yet');
			const token = await this.tokenProvider();
			this.setToken(token);
			return token;
		} catch (error) {
			console.error('Error fetching token:', error);
			throw error;
		}
	}
	
	constructor() {
		if (atlasApi.instance) {
			return atlasApi.instance;
		}
		atlasApi.instance = this;
		return this;
	}
	setToken(token){
		this.authToken = token;
	}
	
	async fetchData(){
		try {
			const response = await fetch(`${atlasApi.apiUrl}/data`, { headers: this.headers() });
			const data = await response.json();
			return data;
		} catch (error) {
			console.error('Error fetching data:', error);
			throw error;
		}
	}

	async postData(postData){
		try {
			const response = await fetch(`${atlasApi.apiUrl}/post`, {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(postData),
			});

			const data = await response.json();
			return data;
		} catch (error) {
			console.error('Error posting data:', error);
			throw error;
		}
	}

	async getProjects(){
		try {
			const response = await fetch(this.projectsEndpoint(), { headers: this.headers() });
			const projects = await response.text();
			return projects;
		} catch (error) {
			console.error('Error fetching projects:', error);
			throw error;
		}
	}
	async getProjectsMini(){
		try {
			const response = await fetch(this.projectsMiniEndpoint(), { headers: this.headers() });
			const projects = await response.text();
			return projects;
		} catch (error) {
			console.error('Error fetching projects:', error);
			throw error;
		}
	}
	async getProjectsBoundaries(){
		try {
			const response = await fetch(this.projectsBoundariesEndpoint(''), { headers: this.headers() });
			const projects = await response.json();
			return projects;
		} catch (error) {
			console.error('Error fetching projects:', error);
			throw error;
		}
	}

	async getProject(projectId, uId){
		try {
			const response = await fetch(this.projectEndpoint(projectId), { 
				headers:this.headers()
			});
			const project = await response.json();
			return project;
		} catch (error) {
			console.error('Error fetching project:', error);
			throw error;
		}
	}

	async getScenarios(projectId){
		try {
			const response = await fetch(this.scenariosEndpoint(projectId), { headers: this.headers() });
			const scenarios = await response.json();
			return scenarios;
		} catch (error) {
			console.error('Error fetching project scenarios:', error);
			throw error;
		}
	}

	async getScenario(projectId, scenarioId, versionId, workmode, kwh_price, aep){
		try {
			const response = await fetch(this.scenarioEndpoint(projectId, scenarioId, versionId, workmode, kwh_price, aep), { 
				headers:this.headers()
			});
			const scenario = await response.json();
			
			if(!scenario.properties || !scenario.properties.features)
				scenario.properties = this.emptySet;
			return scenario;
		} catch (error) {
			console.error('Error fetching project scenario:', error);
			throw error;
		}
	}

	async getScenarioOwners(projectId, scenarioId, versionId){
		try {
			const response = await fetch(this.scenarioOwnersEndpoint(projectId, scenarioId, versionId), { headers: this.headers() });
			const owners = await response.json();
			owners.map((o)=>{
				if(o.dialogs && o.dialogs.length){
					o.dialogs.map((dialog)=>{
						var d = new Date(dialog.timestamp);
						dialog.timestamp = ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth()+1)).slice(-2) + '/' + d.getFullYear();
					})
				}
				return o;
			});
			return owners;
		} catch (error) {
			console.error('Error fetching project scenario:', error);
			throw error;
		}
	}

//	getScenarioProperties(projectId, scenarioId, versionId){
//		try {
//			const response = await fetch(scenarioPropertiesEndpoint(projectId, scenarioId, versionId), { headers });
//			const properties = await response.json();
//			return properties;
//		} catch (error) {
//			console.error('Error fetching project scenario:', error);
//			throw error;
//		}
//	},

	async getTurbines(projectId, scenarioId){
		try {
			const response = await fetch(this.turbinesEndpoint(projectId, scenarioId), {
				method: 'GET',
				headers: this.headers(),
			});
			const turbs = await response.json();
			return turbs;
		} catch (error) {
			console.error('Error fetching scenario turbine locations:', error);
			throw error;
		}
	}

	async createScenario(projectId, newScenarioData){
		try {
			const response = await fetch(this.scenariosEndpoint(projectId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(newScenarioData),
			});

			const newScenario = await response.json();
			return newScenario;
		} catch (error) {
			console.error('Error creating scenario:', error);
			throw error;
		}
	}

	async createTurbine(projectId, scenarioId, latitude, longitude, name){
		try {
			const response = await fetch(this.turbinesEndpoint(projectId, scenarioId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({ latitude, longitude, name }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error creating turbine:', error);
			throw error;
		}
	}

	async deleteScenario(scenario, username){
		try {
			const response = await fetch(this.scenarioEndpoint(scenario.projectid, scenario.scenario_id ?? scenario.scenarioid), {
				method: 'DELETE',
				headers: this.headers(),
				body: JSON.stringify({}),
			});

			if (response.ok) {
				return { success: true };
			} else {
				const errorData = await response.json();
				throw new Error(errorData.message);
			}
		} catch (error) {
			console.error('Error deleting scenario:', error);
			throw error;
		}
	}

	async deleteTurbine(projectId, scenarioId, turbineId){
		try {
			const response = await fetch(this.turbineEndpoint(projectId, scenarioId, turbineId), {
				method: 'DELETE',
				headers: this.headers(),
			});
			if (response.ok) {
				return await response.json();;
			} else {
				const errorData = await response.json();
				throw new Error(errorData.message);
			}
		} catch (error) {
			console.error('Error deleting turbine:', error);
			throw error;
		}
	}
	async updateScenario(scenario){
		//prepare payload
		var payload = {...scenario};
		
		if(payload.boundary)
			payload.boundary = {...payload.boundary.geometry};
		
		if(payload.wtgs)
			payload.wtgs.forEach((turbine)=>{
				if(typeof turbine.turbineid != 'number')
					delete turbine.turbineid;
			});
		if(payload.nsas)
			payload.nsas.forEach((sensor)=>{
				if(typeof sensor.nsaid != 'number')
					delete sensor.nsaid;
			});

		try {
			const response = await fetch(this.scenarioEndpoint(payload.projectid, payload.scenario_id ?? payload.scenarioid), {
				method: 'PUT',
				headers: this.headers() ,
				body: JSON.stringify(payload),
			});

			const updatedScenario = await response.json();
			return updatedScenario;
		} catch (error) {
			console.error('Error updating project scenario:', error);
			throw error;
		}
	}
	async updateTurbine(projectId, scenarioId, turbineId, latitude, longitude){
		try {
			const response = await fetch(this.turbineEndpoint(projectId, scenarioId, turbineId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({ latitude, longitude }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating turbine:', error);
			throw error;
		}
	}
	async updateOwner(owner){
		

		try {
			const response = await fetch(this.ownerEndpoint(owner.id), {
				method: (owner.id ? 'PUT' : 'POST'),
				headers: this.headers(),
				body: JSON.stringify(owner),
			});

			const updatedOwner = await response.json();
			return updatedOwner;
		} catch (error) {
			console.error('Error updating owner:', error);
			throw error;
		}
	}
	async updateProperty(pId, status, workMode, ownerId, country){

		try {
			const response = await fetch(this.propertyEndpoint(), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({id:pId, status:status, workMode:workMode, landownerId:ownerId, country:country}),
			});
			const updatedProperty = await response.json()
			return updatedProperty;
		} catch (error) {
			console.error('Error updating owner:', error);
			throw error;
		}
	}
	async updatePropertyOwner(data, oId){

		try {
			const response = await fetch(this.updatePropertyOwnEndpoint(oId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});
			const updatedOwner = await response.json()
			return updatedOwner;
		} catch (error) {
			console.error('Error updating owner:', error);
			throw error;
		}
	}
	async createProject(newProjectData){
		try {
			const response = await fetch(this.projectsEndpoint(), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(newProjectData),
			});

			const newProject = await response.json();
			return newProject;
		} catch (error) {
			console.error('Error creating scenario:', error);
			throw error;
		}
	}
	async requestOwners(projectId, scenarioId, workmode){
		try {
			const response = await fetch(this.requestOwnersEndpoint(projectId, scenarioId, workmode));

			const resp = await response.text();
			return resp;
		} catch (error) {
			console.error('Error requesting owners:', error);
			throw error;
		}
	}
	async setMainScenario(pId, sId, data){
		try {
			const response = await fetch(this.setMainScenarioEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating scenario:', error);
			throw error;
		}
	}
	async getScenarioChanges(pId, sId, limit = 50){
		try {
			const response = await fetch(this.scenarioChangesEndpoint(pId, sId, limit), {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching scenario changes:', error);
			throw error;
		}
	}
	async undoChange(pId, sId, changeId){
		try {
			const response = await fetch(this.undoEndpoint(pId, sId, changeId), {
				method: 'POST',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error undoing change:', error);
			throw error;
		}
	}
	async redoChange(pId, sId, changeId = null){
		try {
			const response = await fetch(this.redoEndpoint(pId, sId, changeId), {
				method: 'POST',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error redoing change:', error);
			throw error;
		}
	}
	async copyScenarioFromChange(pId, sId, changeId, name){
		try {
			const response = await fetch(this.changeCopyEndpoint(pId, sId, changeId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({ name }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error copying scenario from change:', error);
			throw error;
		}
	}

	async getChangePreview(pId, sId, changeId){
		try {
			const response = await fetch(this.changePreviewEndpoint(pId, sId, changeId), {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching change preview:', error);
			throw error;
		}
	}
	async getScenarioVersions(projectId, scenarioId){
		try {
			const response = await fetch(this.getScenarioHistEndpoint(projectId, scenarioId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error requesting owners:', error);
			throw error;
		}
	}
	async getPlotInfo(plots, country){
		var data = {
			"properties" : plots,
			"country": country
		};
		try {
			const response = await fetch(this.requestPlotInfoEndpoint(), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			if (response.ok) {
				return { success: true, data:await response.json()};
			} else {
				const errorData = await response.json();
				return { success: false, message: errorData.message};
			}
		} catch (error) {
			return { success: false, message: error};
		}
	}
	async addDialog(oId, data){
		try {
			const response = await fetch(this.addDialogEndpoint(oId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error adding dialog:', error);
			throw error;
		}
	}
	async projectState(pId, data){
		try {
			const response = await fetch(this.projectStateEndpoint(pId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error changing state:', error);
			throw error;
		}
	}
	async getSettings(user){
		try {
			const response = await fetch(this.settingsEndpoint(), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting settings:', error);
			throw error;
		}
	}
	async updateSettings(data){

		try {
			const response = await fetch(this.settingsEndpoint(), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});
			const updatedSettings = await response.json()
			return updatedSettings;
		} catch (error) {
			console.error('Error updating user:', error);
			throw error;
		}
	}
	async addNotes(pId, data){
		try {
			const response = await fetch(this.notesEndpoint(pId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error adding notes:', error);
			throw error;
		}
	}
	async searchOwners(params){
		try {
			const response = await fetch(this.searchLandOwners(params), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error searching owners:', error);
			throw error;
		}
	}
	async searchProperties(query){
		try {
			const response = await fetch(this.searchPropertiesEndpoint(query), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error searching properties:', error);
			throw error;
		}
	}
	async deleteDialog(id_dialog){
		try {
			const response = await fetch(this.deleteDialogEndpoint(id_dialog), {
				method: 'DELETE',
				headers: this.headers(),
				body: {},
			});

			if (response.ok) {
				return { success: true };
			} else {
				const errorData = await response.json();
				throw new Error(errorData.message);
			}
		} catch (error) {
			console.error('Error deleting scenario:', error);
			throw error;
		}
	}
	async disassociateProperty(idOwner, idProperty){
		try {
			const response = await fetch(this.disassociatePropEndpoint(idOwner), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({propertyId:idProperty}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error disassociating properties:', error);
			throw error;
		}
	}
	async convertLayer(formData){
		try {
			const response = await fetch(this.convertLayerEndpoint(), {
				method: 'POST',
				headers: this.uploadHeaders(),
				body: formData,
			});

			if (!response.ok) {
				// The API answers {error: ...}; a crashed worker may not answer JSON at all
				const errorData = await response.json().catch(() => ({}));
				throw new Error(errorData.error || errorData.message || 'Could not read the file');
			}

			const uploadedFileResponse = await response.json();
			return uploadedFileResponse;
		} catch (error) {
			console.error('Error uploading file:', error);
			throw error;
		}
	}
	async getLayers(username, pId){
		try {
			const response = await fetch(this.getLayerLibrary(pId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error searching owners:', error);
			throw error;
		}
	}
	async uploadFile(formData){
		try {
			const response = await fetch(this.uploadLayerLibrary(), {
				method: 'POST',
				headers:this.uploadHeaders(),
				body: formData,
			});

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.message);
			}

			const uploadedFileResponse = await response.json();
			return uploadedFileResponse;
		} catch (error) {
			console.error('Error uploading file:', error);
			throw error;
		}
	}
	async addToLibrary(lId, formData){
		try {
			const response = await fetch(this.uploadedLayerEndpoint(lId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(formData),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating layer:', error);
			throw error;
		}
	}
	async saveLayerConfig(pId, sId, data){
		try {
			const response = await fetch(this.layerConfigEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating layer:', error);
			throw error;
		}
	}
	/* Radene til attributtabellen under kartet. Serversiden teller, sorterer og
	   filtrerer — se kommentaren over endepunktet i uploads.py for hvorfor det
	   ikke kan gjoeres fra flisene. */
	async getLayerFeatures(table, opts = {}) {

		const q = new URLSearchParams();

		q.append('limit', opts.limit || 100);
		q.append('offset', opts.offset || 0);

		/* Markoeren er siste leste ctid. Uten sortering blar serveren med den i
		   stedet for offset — se _features_by_ctid i uploads.py: offset koster
		   sekunder paa dype sider, markoeren er like rask overalt. */
		if(opts.cursor)
			q.append('cursor', opts.cursor);

		/* Tellingene endrer seg ikke mens man ruller, bare naar panelet aapner
		   eller filtrene endres. */
		if(opts.counts === false)
			q.append('counts', '0');

		if(opts.orderBy){
			q.append('order_by', opts.orderBy);
			q.append('dir', opts.dir || 'asc');
		}
		if(opts.filters && opts.filters.length)
			q.append('filters', JSON.stringify(opts.filters));
		if(opts.projectId)
			q.append('project_id', opts.projectId);

		const response = await fetch(this.layerFeaturesEndpoint(table, q.toString()), {
			method: 'GET',
			headers: this.headers(),
		});

		if(!response.ok){
			const error = await response.json().catch(()=>({}));
			throw new Error(error.message || 'Could not load layer features');
		}

		return response.json();
	}
	async getLayerProperties (lId) {
		try {
			const response = await fetch(this.layerPropertiesEndpoint(lId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error searching owners:', error);
			throw error;
		}
	}
	async downloadProjectFile(pId, sId, data){
		try {
			const response = await fetch(this.downloadProjectFileEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});
			if(response.status != 200)
				return false;
			const resp = await response.blob();
			return resp;
		} catch (error) {
			console.error('Error updating layer:', error);
			throw error;
		}
	}
	async getPropertyPreviousOwners(pId) {
		try {
			const response = await fetch(this.getPreviousOwnersEndpoint(pId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error searching owners:', error);
			throw error;
		}
	}
	async downloadLibLayer(layerId){
		try {
			const response = await fetch(this.downloadLibLayerEndpoint(layerId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.blob();
			return resp;
		} catch (error) {
			console.error('Error updating layer:', error);
			throw error;
		}
	}
	async deleteLayer(layerId){
		try {
			const response = await fetch(this.deleteLayerEndpoint(layerId), {
				method: 'DELETE',
				headers: this.headers(),
				body: {},
			});

			
			return await response.json();
			
		} catch (error) {
			console.error('Error deleting scenario:', error);
			throw error;
		}
	}
	async getBoundingBox(layerId){
		try {
			const response = await fetch(this.uploadedLayerBBEndpoint(layerId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting layer:', error);
			throw error;
		}
	}
	async setRoadWidth(idProject, idScenario, idRoad, width){
		try {
			const response = await fetch(this.setRoadWidthEndpoint(idProject, idScenario, idRoad, width), {
				method: 'PUT',
				headers: this.headers()
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error setting width:', error);
			throw error;
		}
	}
	async createPowerline(pId, sId, geometry, name, width, color){
		try {
			const response = await fetch(this.powerlinesEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({ geometry, name, width, color }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error creating powerline:', error);
			throw error;
		}
	}
	async updatePowerline(pId, sId, plId, data){
		try {
			const response = await fetch(this.powerlineEndpoint(pId, sId, plId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating powerline:', error);
			throw error;
		}
	}
	async deletePowerline(pId, sId, plId){
		try {
			const response = await fetch(this.powerlineEndpoint(pId, sId, plId), {
				method: 'DELETE',
				headers: this.headers(),
			});
			if(response.ok) return { success: true };
			const errorData = await response.json();
			throw new Error(errorData.message);
		} catch (error) {
			console.error('Error deleting powerline:', error);
			throw error;
		}
	}
	async createRoad(pId, sId, roads){
		try {
			const payload = Array.isArray(roads) ? roads : [roads];
			const response = await fetch(this.roadsEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(payload)
			});
			if(response.ok) return await response.json();
			const errorData = await response.json();
			throw new Error(errorData.message);
		} catch (error) {
			console.error('Error creating road:', error);
			throw error;
		}
	}
	async updateRoad(pId, sId, rId, data){
		try {
			const response = await fetch(this.roadEndpoint(pId, sId, rId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data)
			});
			if(response.ok) return await response.json();
			const errorData = await response.json();
			throw new Error(errorData.message);
		} catch (error) {
			console.error('Error updating road:', error);
			throw error;
		}
	}
	async deleteRoad(pId, sId, rId){
		try {
			const response = await fetch(this.roadEndpoint(pId, sId, rId), {
				method: 'DELETE',
				headers: this.headers(),
			});
			if(response.ok) return { success: true };
			const errorData = await response.json();
			throw new Error(errorData.message);
		} catch (error) {
			console.error('Error deleting road:', error);
			throw error;
		}
	}
	async syncAutoroadsRoutes(pId, sId) {
		const response = await fetch(this.autoroadsRoutesSyncEndpoint(pId, sId), {
			method: 'PUT',
			headers: this.headers(),
		});
		return response;
	}
	async getAutoroadsRoutes(pId, sId) {
		try {
			const response = await fetch(this.autoroadsRoutesEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching autoroads routes:', error);
			throw error;
		}
	}
	async triggerAutoroadsCalculation(pId, sId, name) {
		try {
			const body = name ? { name } : { name: `Scenario ${sId} - Turbines` };
			const response = await fetch(this.autoroadsCalculateEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(body),
			});
			return await response.json();
		} catch (error) {
			console.error('Error triggering autoroads calculation:', error);
			throw error;
		}
	}
	async getAutoroadsCalculation(pId, sId) {
		try {
			const response = await fetch(this.autoroadsCalculationEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching autoroads calculation:', error);
			throw error;
		}
	}
	async getAutoroadsMapping(pId) {
		try {
			const response = await fetch(this.autoroadsMappingEndpoint(pId), {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching autoroads mapping:', error);
			throw error;
		}
	}
	async setPowerlineWidth(idProject, idScenario, idRoad, width){
		try {
			const response = await fetch(this.setPowerlineWidthEndpoint(idProject, idScenario, idRoad, width), {
				method: 'PUT',
				headers: this.headers()
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error setting width:', error);
			throw error;
		}
	}
	
	async getPropertyAttributes(propertyId){
		try {
			const response = await fetch(this.getPropAttributesEndpoint(propertyId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting attributes:', error);
			throw error;
		}
	}
	async newPropertyAttribute(data, propertyId){
		try {
			const response = await fetch(this.getPropAttributesEndpoint(propertyId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating attributes:', error);
			throw error;
		}
	}
	async setPropertyAttributes(data, propertyId){
		try {
			const response = await fetch(this.propAttributeEndpoint(propertyId, data.attribute_id), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting attributes:', error);
			throw error;
		}
	}
	async deleteAttribute(attributeId, propertyId){
		try {
			const response = await fetch(this.propAttributeEndpoint(propertyId, attributeId), {
				method: 'DELETE',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error deleting attributes:', error);
			throw error;
		}
	}
	async getUserMaps(email){
		try {
			const response = await fetch(this.getUserMapsEndpoint(email), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting attributes:', error);
			throw error;
		}
	}
	async saveUserMap(data, email){
		try {
			const response = await fetch(this.userMapsEndpoint(), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async updateUserMap(data){
		try {
			const response = await fetch(this.getUserMapEndpoint(data.id), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async deleteUserMap(data){
		try {
			const response = await fetch(this.getUserMapEndpoint(data.id), {
				method: 'DELETE',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async duplicateUserMap(data){
		try {
			const response = await fetch(this.copyUserMapEndpoint(data.id), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async getPropertyBB(vindrId){
		try {
			const response = await fetch(this.propertyBBEndpoint(), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting layer:', error);
			throw error;
		}
	}
	async searchCadastralBG(query){
		try {
			const response = await fetch(this.cadastralSearchBGEndpoint(query), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error searching cadastral numbers:', error);
			throw error;
		}
	}
	async getCadastralFeaturesBG(cadnums){
		try {
			const response = await fetch(this.cadastralFeaturesBGEndpoint(), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({cadnums}),
			});

			const resp = await response.json();
			if(!response.ok)
				throw new Error(resp.error || 'Could not fetch cadastral parcels');
			return resp;
		} catch (error) {
			console.error('Error getting cadastral features:', error);
			throw error;
		}
	}
	async getWindRose(pId){
		try {
			const response = await fetch(this.windRoseEndpoint(pId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.blob();
			return resp;
		} catch (error) {
			console.error('Error getting attributes:', error);
			throw error;
		}
	}
	async getWindSpeed(pId, lat,lng){
		try {
			const response = await fetch(this.windSpeedEndpoint(pId, lat,lng), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting attributes:', error);
			throw error;
		}
	}
	async createBuffer(data, uId, m){
		try {
			const response = await fetch(this.createBufferEndpoint(uId, m), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating buffer:', error);
			throw error;
		}
	}
	async getScenarioAEP(pId, sId){
		try {
			const response = await fetch(this.scenarioAEPEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting aep:', error);
			throw error;
		}
	}
	async updateOwnerColor(data){
		try {
			const response = await fetch(this.setColorEndpoint(data.id), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting aep:', error);
			throw error;
		}
	}
	async getTurbineTypes(){
		if (this._pending.getTurbineTypes) return this._pending.getTurbineTypes;
		const signal = this.createSignal("turbines");
		this._pending.getTurbineTypes = fetch(this.turbineTypesEndpoint(), {
			method: 'GET',
			headers: this.headers(),
			signal
		}).then(r => r.json()).catch(error => {
			if (error.name === 'AbortError') return [];
			console.error('Error getting types:', error);
			throw error;
		}).finally(() => {
			delete this._pending.getTurbineTypes;
		});
		return this._pending.getTurbineTypes;
	}
	async getTurbineHeights(h){
		const key = 'getTurbineHeights_' + (h ?? '');
		if (this._pending[key]) return this._pending[key];
		const signal = this.createSignal("turbines");
		this._pending[key] = fetch(this.turbineHeightsEndpoint(h), {
			method: 'GET',
			headers: this.headers(),
			signal
		}).then(r => r.json()).catch(error => {
			if (error.name === 'AbortError') return {};
			console.error('Error getting heights:', error);
			throw error;
		}).finally(() => {
			delete this._pending[key];
		});
		return this._pending[key];
	}
	async getPlotInfoProgressive(plots, country, workmode, projectid){
		var data = {
			"properties" : plots,
			"country": country,
			"channel": "get-landowners-"+workmode+'-'+projectid
		};
		try {
			const response = await fetch(this.requestPlotInfoEndpointP(), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			if (response.ok) {
				return { success: true, data:await response.json()};
			} else {
				const errorData = await response.json();
				return { success: false, message: errorData.message};
			}
		} catch (error) {
			return { success: false, message: error};
		}
	}
	requestProgress(wm, pId){
		
		return new sseclient(this.getRequestProgress(wm, pId), {
			headers: this.headers()
		});
	}
	
	
	async newScenarioAEP(pId, sId){
		try {
			const response = await fetch(this.scenarioAEPEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting aep:', error);
			throw error;
		}
	}

	async updateTurbineName(data, pId, sId, tId,){
		try {
			const response = await fetch(this.turbineNameEndpoint(pId, sId, tId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error saving name:', error);
			throw error;
		}
	}
	async getNoiseLayer(pId, sId){
		const key = `getNoiseLayer_${pId}_${sId}`;
		if (this._pending[key]) return this._pending[key];
		const signal = this.createSignal("sensors");
		this._pending[key] = fetch(this.noiseLayerEndpoint(pId, sId), {
			method: 'GET',
			headers: this.headers(),
			signal
		}).then(r => r.json()).catch(error => {
			if (error.name === 'AbortError') return null;
			console.error('Error getting layer:', error);
			throw error;
		}).finally(() => {
			delete this._pending[key];
		});
		return this._pending[key];
	}
	async startNoiseLayer(pId, sId){
		const signal = this.createSignal("sensors");
		try {
			const response = await fetch(this.noiseLayerEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				signal
			});

			const resp = await response.json();
			return resp;
		} catch (error)  {
			if (error.name === 'AbortError') 
				console.log('Request canceled');
			else {
				console.error('Error starting layer:', error);
				throw error;
			}
		}
	}
	async getShadowLayer(pId, sId){
		const key = `getShadowLayer_${pId}_${sId}`;
		if (this._pending[key]) return this._pending[key];
		const signal = this.createSignal("sensors");
		this._pending[key] = fetch(this.shadowLayerEndpoint(pId, sId), {
			method: 'GET',
			headers: this.headers(),
			signal
		}).then(r => r.json()).catch(error => {
			if (error.name === 'AbortError') return null;
			console.error('Error getting layer:', error);
			throw error;
		}).finally(() => {
			delete this._pending[key];
		});
		return this._pending[key];
	}
	async startShadowLayer(pId, sId){
		const signal = this.createSignal("sensors");
		try {
			const response = await fetch(this.shadowLayerEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			if (error.name === 'AbortError') 
				console.log('Request canceled');
			else {
				console.error('Error starting layer:', error);
				throw error;
			}
		}
	}
	
	async getAnnotations(pId, sId){
		try {
			const response = await fetch(this.annotationsEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async createAnnotations(pId, sId, data){
		try {
			const response = await fetch(this.annotationsEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async updateAnnotations(pId, sId, data){
		try {
			const response = await fetch(this.annotationEndpoint(pId, sId, data.id), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async deleteAnnotations(pId, sId, aId){
		try {
			const response = await fetch(this.annotationEndpoint(pId, sId, aId), {
				method: 'DELETE',
				headers: this.headers(),
				//body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	
	async addProjectLayer(lId, pId){
		try {
			const response = await fetch(this.addLayerProjectEndpoint(lId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({project_id:pId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async setFavorite(v, pId, uId){
		try {
			const response = await fetch(this.favoritesEndpoint(), {
				method: v ? 'POST' : 'DELETE',
				headers: this.headers(),
				body: JSON.stringify({
					'project_id': parseInt(pId)
				}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}

	async setFavorite2(type, v, payload, uId){
		try {
			const response = await fetch(this.favoritesEndpointv2(type), {
				method: v ? 'POST' : 'DELETE',
				headers: this.headers(),
				body: JSON.stringify(payload),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error setting favorite:', error);
			throw error;
		}
	}
	async getUsers(){
		try {
			const response = await fetch(this.usersEndpoint(), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting users:', error);
			throw error;
		}
	}
	
	async updateProjectSettings(pId, data){
		try {
			const response = await fetch(this.projectEndpoint(pId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating projects:', error);
			throw error;
		}
	}
	async deleteProject(pId){
		try {
			const response = await fetch(this.projectEndpoint(pId), {
				method: 'DELETE',
				headers: this.headers()
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error deleting projects:', error);
			throw error;
		}
	}
	async addProjectDocs(pId){
		try {
			const response = await fetch(this.docsEndpoint(pId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({})
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating map:', error);
			throw error;
		}
	}
	async getTags(pId){
		try {
			const response = await fetch(this.tagsEndpoint(pId), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting tags:', error);
			throw error;
		}
	}
	async getTagColors(){
		try {
			const response = await fetch(this.tagColorsEndpoint(), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting tags:', error);
			throw error;
		}
	}
	requestCalcProgress(type, pId, sId){
		
		return new sseclient(this.calcProgressEndpoint(type, pId, sId), {
			headers: this.headers()
		});
	}
	async addCircle(pId, sId, data){
		try {
			const response = await fetch(this.circlesEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error creating circle:', error);
			throw error;
		}
	}
	async updateCircle(pId, sId, data, remove){
		try {
			const response = await fetch(this.circleEndpoint(pId, sId, data.id), {
				method: (remove ? 'DELETE':'PUT'),
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating circle:', error);
			throw error;
		}
	}
	
	async getEllipse(pId, sId){
		try {
			const response = await fetch(this.ellipseEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting ellipse:', error);
			throw error;
		}
	}
	async updateEllipse(pId, sId, data){
		try {
			const response = await fetch(this.ellipseEndpoint(pId, sId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating ellipse:', error);
			throw error;
		}
	}
	async downloadAllProjects(format){
		try {
			const response = await fetch(this.downloadProjsEndpoint(format), {
				method: 'GET',
				headers: this.headers(),
			});

			const blob = await response.blob();
			return blob;
		} catch (error) {
			console.error('Error downloading projects:', error);
			throw error;
		}
	}
	async getMetricsPipeline(energyType, dates){
		try {
			const response = await fetch(this.metricsPipelineEndpoint(energyType, dates), { headers: this.headers() });
			const data = await response.json();
			return data;
		} catch (error) {
			console.error('Error fetching metrics pipeline:', error);
			throw error;
		}
	}

	async getMetricsProjects(country, energyType, compareDate){
		try {
			const response = await fetch(this.metricsProjectsEndpoint(country, energyType, compareDate), { headers: this.headers() });
			const text = await response.text();
			const data = JSON.parse(text.replace(/\bNaN\b/g, 'null'));
			return data;
		} catch (error) {
			console.error('Error fetching metrics projects:', error);
			throw error;
		}
	}
	async getExclusions(pid, sId){
		try {
			const response = await fetch(this.exclusionsEndpoint(pid, sId), {
				method: 'GET',
				headers: this.headers(),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting exclusions:', error);
			throw error;
		}
	}
	
	async updateExclusion(data, pId, sId, eId){
		try {
			const response = await fetch(this.exclusionEndpoint(pId, sId, eId), {
				method: data ? 'PUT' : 'DELETE',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating exclusion:', error);
			throw error;
		}
	}
	async createPolyExclusion(data, pId, sId){
		try {
			const response = await fetch(this.exclusionPolyEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating exclusion:', error);
			throw error;
		}
	}
	async createPointExclusion(data, pId, sId){
		try {
			const response = await fetch(this.exclusionPointEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error updating exclusion:', error);
			throw error;
		}
	}
	async getDrawings(pId, sId){
		try {
			const response = await fetch(this.drawingsEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting tags:', error);
			throw error;
		}
	}
	async getDrawing(pId, sId, dId){
		try {
			const response = await fetch(this.drawingEndpoint(pId, sId, dId), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting drawing:', error);
			throw error;
		}
	}
	
	async createDrawing(data, pId, sId){
		try {
			const response = await fetch(this.drawingsEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting tags:', error);
			throw error;
		}
	}
	async updateDrawing(data, pId, sId, dId){
		try {
			const response = await fetch(this.drawingEndpoint(pId, sId, dId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting tags:', error);
			throw error;
		}
	}
	async deleteDrawing(pId, sId, dId){
		try {
			const response = await fetch(this.drawingEndpoint(pId, sId, dId), {
				method: 'DELETE',
				headers: this.headers(),
			//	body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting tags:', error);
			throw error;
		}
	}
	
	async extractExclusion(pId, sId, tId, slope, buffer){
		try {
			const response = await fetch(this.exclusionExtractEndpoint(pId, sId, tId, slope, buffer), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting tags:', error);
			throw error;
		}
	}
	
	async exclusionLayer(formData, params){
		try {
			const response = await fetch(this.exclusionUploadEndpoint(params.projectid, params.scenarioid), {
				method: 'POST',
				headers: this.uploadHeaders(),
				body: formData,
			});

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.message);
			}

			const uploadedFileResponse = await response.json();
			return uploadedFileResponse;
		} catch (error) {
			console.error('Error uploading file:', error);
			throw error;
		}
	}
	async getSensors(projectId, scenarioId){
		try {
			const response = await fetch(this.sensorsEndpoint(projectId, scenarioId), {
				method: 'GET',
				headers: this.headers(),
			});
			const turbs = await response.json();
			return turbs;
		} catch (error) {
			console.error('Error fetching scenario sensor locations:', error);
			throw error;
		}
	}
	
	async createSensor(pId, sId, latitude, longitude, name){
		try {
			const response = await fetch(this.sensorsEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({ geometry: { type: 'Point', coordinates: [longitude, latitude] }, name }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error creating sensor:', error);
			throw error;
		}
	}
	async updateSensor(pId, sId, nsaId, latitude, longitude){
		try {
			const response = await fetch(this.sensorEndpoint(pId, sId, nsaId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({ geometry: { type: 'Point', coordinates: [longitude, latitude] } }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating sensor:', error);
			throw error;
		}
	}
	async deleteSensor(pId, sId, nsaId){
		try {
			const response = await fetch(this.sensorEndpoint(pId, sId, nsaId), {
				method: 'DELETE',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error deleting sensor:', error);
			throw error;
		}
	}
	async updateSensorName(data, pId, sId, nsaId){
		try {
			const response = await fetch(this.sensorEndpoint(pId, sId, nsaId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating sensor name:', error);
			throw error;
		}
	}
	async getCompensation(pId, sId){
		try {
			const response = await fetch(this.compensationEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
				//body: JSON.stringify({vindrid:vindrId}),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting compensation:', error);
			throw error;
		}
	}
	async saveWtgSettings(pId, sId, data){
		try {
			const response = await fetch(this.wtgSettingsEndpoint(pId, sId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});
			return await response.json();
		} catch (error) {
			console.error('Error saving WTG settings:', error);
			throw error;
		}
	}
	async editScenario(pId, sId, data){
		try {
			const response = await fetch(this.scenarioEditEndpoint(pId, sId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify(data),
			});
			return await response.json();
		} catch (error) {
			console.error('Error editing scenario:', error);
			throw error;
		}
	}
	async setCompensation(pId, sId, data){
		try {
			const response = await fetch(this.compensationEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify(data),
			});

			const resp = await response.json();
			return resp;
		} catch (error) {
			console.error('Error getting compensation:', error);
			throw error;
		}
	}
	
	async _bulkDelete(url, ids, label){
		try {
			const response = await fetch(url, {
				method: 'DELETE',
				headers: this.headers(),
				body: JSON.stringify({ ids }),
			});
			if (response.ok) {
				try { return await response.json(); } catch(e) { return { success: true }; }
			}
			const errorData = await response.json().catch(()=>({}));
			throw new Error(errorData.message || `Bulk delete ${label} failed`);
		} catch (error) {
			console.error(`Error bulk deleting ${label}:`, error);
			throw error;
		}
	}

	bulkDeleteTurbines(pId, sId, ids)		{ return this._bulkDelete(this.turbinesEndpoint(pId, sId), ids, 'turbines'); }
	bulkDeleteTurbineCircles(pId, sId, ids)	{ return this._bulkDelete(this.circlesEndpoint(pId, sId), ids, 'turbine circles'); }
	bulkDeleteRoads(pId, sId, ids)			{ return this._bulkDelete(this.roadsEndpoint(pId, sId), ids, 'roads'); }
	bulkDeleteSensors(pId, sId, ids)		{ return this._bulkDelete(this.sensorsEndpoint(pId, sId), ids, 'sensors'); }
	bulkDeletePowerlines(pId, sId, ids)		{ return this._bulkDelete(this.powerlinesEndpoint(pId, sId), ids, 'powerlines'); }
	bulkDeleteExclusions(pId, sId, ids)		{ return this._bulkDelete(this.exclusionsEndpoint(pId, sId), ids, 'exclusions'); }
	bulkDeleteDrawings(pId, sId, ids)		{ return this._bulkDelete(this.drawingsEndpoint(pId, sId), ids, 'drawings'); }
	bulkDeleteAnnotations(pId, sId, ids)	{ return this._bulkDelete(this.annotationsEndpoint(pId, sId), ids, 'annotations'); }
	bulkDeleteGates(pId, sId, ids)			{ return this._bulkDelete(this.gatesEndpoint(pId, sId), ids, 'gates'); }
	bulkDeleteSubstations(pId, sId, ids)	{ return this._bulkDelete(this.substationsEndpoint(pId, sId), ids, 'substations'); }

	async createGate(pId, sId, lat, lng, name) {
		try {
			const response = await fetch(this.gatesEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({ latitude: lat, longitude: lng, name }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error creating gate:', error);
			throw error;
		}
	}

	async updateGate(pId, sId, gId, lat, lng) {
		try {
			const response = await fetch(this.gateEndpoint(pId, sId, gId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({ latitude: lat, longitude: lng }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating gate:', error);
			throw error;
		}
	}

	async updateGateName(pId, sId, gId, name) {
		try {
			const response = await fetch(this.gateEndpoint(pId, sId, gId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({ name }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating gate name:', error);
			throw error;
		}
	}

	async deleteGate(pId, sId, gId) {
		try {
			const response = await fetch(this.gateEndpoint(pId, sId, gId), {
				method: 'DELETE',
				headers: this.headers(),
			});
			if (response.ok) {
				try { return await response.json(); } catch(e) { return { success: true }; }
			}
			const errorData = await response.json().catch(() => ({}));
			throw new Error(errorData.message || 'Delete gate failed');
		} catch (error) {
			console.error('Error deleting gate:', error);
			throw error;
		}
	}

	async getSubstations(pId, sId) {
		try {
			const response = await fetch(this.substationsEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching substations:', error);
			throw error;
		}
	}

	async getEntryGates(pId, sId) {
		try {
			const response = await fetch(this.gatesEndpoint(pId, sId), {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching entry gates:', error);
			throw error;
		}
	}

	async createSubstation(pId, sId, lat, lng, name) {
		try {
			const response = await fetch(this.substationsEndpoint(pId, sId), {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({ latitude: lat, longitude: lng, name }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error creating substation:', error);
			throw error;
		}
	}

	async updateSubstation(pId, sId, ssId, lat, lng) {
		try {
			const response = await fetch(this.substationEndpoint(pId, sId, ssId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({ latitude: lat, longitude: lng }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating substation:', error);
			throw error;
		}
	}

	async updateSubstationName(pId, sId, ssId, name) {
		try {
			const response = await fetch(this.substationEndpoint(pId, sId, ssId), {
				method: 'PUT',
				headers: this.headers(),
				body: JSON.stringify({ name }),
			});
			return await response.json();
		} catch (error) {
			console.error('Error updating substation name:', error);
			throw error;
		}
	}

	async deleteSubstation(pId, sId, ssId) {
		try {
			const response = await fetch(this.substationEndpoint(pId, sId, ssId), {
				method: 'DELETE',
				headers: this.headers(),
			});
			if (response.ok) {
				try { return await response.json(); } catch(e) { return { success: true }; }
			}
			const errorData = await response.json().catch(() => ({}));
			throw new Error(errorData.message || 'Delete substation failed');
		} catch (error) {
			console.error('Error deleting substation:', error);
			throw error;
		}
	}

	async getReportStatus(pId, sId) {
		try {
			const response = await fetch(this.reportsEndpoint(pId, sId)+'status/', {
				method: 'GET',
				headers: this.headers(),
			});
			return await response.json();
		} catch (error) {
			console.error('Error fetching report status:', error);
			throw error;
		}
	}
	
	async downloadProjectReport(pId, sId, data){
		try {
			const response = await fetch(this.reportsEndpoint(pId, sId)+'?types='+data.properties.join(","), {
				method: 'GET',
				headers: this.headers(),
			});
			if(response.status != 200)
				return false;
			const resp = await response.blob();
			return resp;
		} catch (error) {
			console.error('Error updating layer:', error);
			throw error;
		}
	}
	createSignal(type) {
		
		//gets the api caller method name
		const request = new Error().stack.split('\n')[2].trim().split(' ')[1].split('.').pop();

		if (!this.requestSignals[type])
			this.requestSignals[type] = {};

		this.requestSignals[type][request]?.abort();

		const controller = new AbortController();
		this.requestSignals[type][request] = controller;
		return controller.signal;
	}
	
	abortRequests(type) {
		const types = type ? [type] : Object.keys(this.requestSignals);
		types.forEach(t => {
			Object.values(this.requestSignals[t] ?? {}).forEach(c => c.abort());
			delete this.requestSignals[t];
		});
	}
};

export default new atlasApi();